import type { TFunction } from "i18next";
import type { PaginationLabels } from "@/components/ui/Pagination";

/** Labels for DataTable / table preferences — maps to `common:table.*` keys. */
export type DataTableLabels = PaginationLabels & {
  resizeColumn: string;
  resizeColumnFor: (column: string) => string;
  selectRow: string;
  selectionColumn: string;
  selectionHint: string;
  selectedCount: (count: number) => string;
  selectAllOnPage: string;
  clearSelection: string;
  reorderColumn: string;
  preferencesTitle: string;
  preferencesDescription: string;
  preferencesReset: string;
  preferencesCancel: string;
  preferencesConfirm: string;
  preferencesPageSize: string;
  preferencesColumns: string;
  preferencesColumnsHint: string;
  preferencesOpen: string;
};

/** Build table labels from the caller's `useTranslation("common")` `t`. */
export function buildDataTableLabels(t: TFunction<"common">): DataTableLabels {
  return {
    nextPage: t("table.nextPage"),
    previousPage: t("table.previousPage"),
    rowsPerPage: t("table.rowsPerPage"),
    pageOf: (page, totalPages) => t("table.pageOf", { page, totalPages }),
    paginationSummary: (start, end, total) =>
      t("table.paginationSummary", { start, end, total }),
    resizeColumn: t("table.resizeColumn"),
    resizeColumnFor: (column) => t("table.resizeColumnFor", { column }),
    selectRow: t("table.selectRow"),
    selectionColumn: t("table.selectionColumn"),
    selectionHint: t("table.selectionHint"),
    selectedCount: (count) => t("table.selectedCount", { count }),
    selectAllOnPage: t("table.selectAllOnPage"),
    clearSelection: t("table.clearSelection"),
    reorderColumn: t("table.reorderColumn"),
    preferencesTitle: t("table.preferencesTitle"),
    preferencesDescription: t("table.preferencesDescription"),
    preferencesReset: t("table.preferencesReset"),
    preferencesCancel: t("table.preferencesCancel"),
    preferencesConfirm: t("table.preferencesConfirm"),
    preferencesPageSize: t("table.preferencesPageSize"),
    preferencesColumns: t("table.preferencesColumns"),
    preferencesColumnsHint: t("table.preferencesColumnsHint"),
    preferencesOpen: t("table.preferencesOpen"),
  };
}
